import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { lightTheme, darkTheme } from './styles/theme.css'
import { BlogPage } from '@pages/blog'
import { PostPage } from '@pages/post'
import { AuthorPage } from '@pages/author'
import { AboutPage } from '@pages/about'
import { AffiliateDisclosurePage, PrivacyPolicyPage } from '@pages/legal'
import { NotFoundPage } from '@pages/not-found'
import { useAppStore } from '@shared/store'
import { AnalyticsTracker } from './AnalyticsTracker'

/** Fade out and remove the boot splash (index.html) once the app has painted. */
function dismissSplash() {
  const el = document.getElementById('app-splash')
  if (!el) return
  el.classList.add('app-splash--done')
  const remove = () => el.remove()
  el.addEventListener('transitionend', remove, { once: true })
  // Fallback in case transitionend never fires (e.g. reduced-motion / display quirks)
  window.setTimeout(remove, 700)
}

export function App() {
  const isDarkMode = useAppStore((s) => s.isDarkMode)

  useEffect(() => {
    dismissSplash()
  }, [])
  return (
    <div className={isDarkMode ? darkTheme : lightTheme}>
      <BrowserRouter>
        <Routes>
          {/* Blog index is the homepage. */}
          <Route path="/" element={<BlogPage />} />
          <Route path="/category/:category" element={<BlogPage />} />

          {/* Localized blog archives and post URLs. English keeps its original
           * Legacy English paths stay stable. Translations are explicitly namespaced so a
           * translated slug can never shadow an English permalink. */}
          <Route path="/fr" element={<BlogPage />} />
          <Route path="/fr/category/:category" element={<BlogPage />} />
          <Route path="/fr/:year/:month/:day/:slug" element={<PostPage />} />
          <Route path="/es" element={<BlogPage />} />
          <Route path="/es/category/:category" element={<BlogPage />} />
          <Route path="/es/:year/:month/:day/:slug" element={<PostPage />} />

          {/* Static pages at their established public paths. */}
          <Route path="/about" element={<AboutPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/affiliate-disclosure" element={<AffiliateDisclosurePage />} />
          <Route path="/editorial-policy" element={<Navigate to="/about" replace />} />
          <Route path="/author/patrick-ivern" element={<AuthorPage />} />

          {/* Posts at the preserved /YYYY/MM/DD/slug/ permalink */}
          <Route path="/:year/:month/:day/:slug" element={<PostPage />} />

          {/* Preserve an honest not-found state for broken client-side links. */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <AnalyticsTracker />
      </BrowserRouter>
    </div>
  )
}
